import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import toastr from 'toastr'
import Dropzone from "react-dropzone";
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import { Link } from "react-router-dom";
import axios from "axios";

const RatingGroup = [
	{ 
		label: "Rating",
		options: [
                { label: "1", value: "1" },
                { label: "2", value: "2" },
                { label: "3", value: "3" },
                { label: "4", value: "4" },
                { label: "5", value: "5" },
		]
	}
];

class AddHotels extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 3, 'create' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      loading: false,
      selectedFiles: [],
      rejectedFiles:[],
      facilityloding:false,
      typeloading:false,
      sq2: true,

      breadcrumbItems: [
        { title: "Hotels", link: "/hotels" },
        { title: "Add New Hotel", link: "#" },
      ],
      description:"",
      selectedType: "",
      selectedFacilities:[],
      selectedRating:{ label: "3", value: "3" }, 
      selectedLocationsGroup: { label: "Select Place", value: "" },
      selectedDestination: { label: "Select Destination", value: "" },
      LocationGroup :[],
      DestinationGroup:[],
      FacilityGroup: [],
      RoomGroup:"",
      TypeGroup:"",
      count:1,
      errors:false,
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	
    this.onInputChange = this.onInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacilitySubmit = this.handleFacilitySubmit.bind(this);
    this.handleHotelTypeSubmit = this.handleHotelTypeSubmit.bind(this);
    this.handleSelectLocationGroup = this.handleSelectLocationGroup.bind(this);
    this.handleSelectDestinationGroup = this.handleSelectDestinationGroup.bind(this);
    this.handleselectedTypeGroup = this.handleselectedTypeGroup.bind(this);
    this.handleselectedRatingGroup = this.handleselectedRatingGroup.bind(this);
    this.handleselectedFacilityGroup = this.handleselectedFacilityGroup.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleRejectedFiles = this.handleRejectedFiles.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_type = this.tog_type.bind(this);
    this.removeInput = this.removeInput.bind(this);
    this.addInput = this.addInput.bind(this);
    this.onPlaceInputChange = this.onPlaceInputChange.bind(this)
    
  }

  tog_center() {
    this.setState(prevState => ({
      model_facilities: !prevState.model_facilities
    }));
    this.removeBodyCss();
  }
  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }


  addInput(){
    const {count} = this.state
    this.setState({count:count+1})

  }
  removeInput(){
    const {count} = this.state
    this.setState({count:count-1})

  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/hotels')
  }

  async componentDidMount() {
 
    this.loadDestinationData('?parent=null');
    this.loadTypesData()
    this.loadFacilitiesData()
 }

//  Load Destinations as per filter queryset 
 async loadDestinationData(filer_queryset){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(destination => {
                  options.push({ label: destination.name, value: destination.id })
                })
             
                let DestinationGroup = [
                  { 
                      label: "Destination",
                      options: options
                  }
              ];
              this.setState({ DestinationGroup:DestinationGroup  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadPlacesData(filer_queryset){
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(place => {
                  options.push({ label: place.name, value: place.id })
                })
            
                let LocationGroup = [
                  { 
                      label: "Places",
                      options: options
                  }
              ];
              this.setState({ LocationGroup:LocationGroup  })      
            
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
}

 async loadTypesData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/hotels/hotels_types/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(type => {
                options.push({ label: type.name, value: type.id })
              })
              let selectedType= ""
              if (options.length >0){
                selectedType = options[0]
              }
              let TypeGroup = [
                { 
                  label: "Hotel Type",
                  options: options
                }
              ];
              this.setState({ TypeGroup: TypeGroup,
                selectedType: selectedType,
              
              })           
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadFacilitiesData() {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/hotels/hotels_facilities/`, requestOptions)
    .then(res => res.json())
    .then(
      (data) => {
        let options = []
        data.map(facility => {
          options.push({ label: facility.name, value: facility.id })
        })
        
        // Add Select All option at the beginning of the options array
        options.unshift({ label: "Select All", value: "all" })
        
        let FacilityGroup = [
          {
            label: "Facilities",
            options: options
          }
        ];
        this.setState({ FacilityGroup: FacilityGroup })
      },
      (error) => {
        console.log(error, 'error--------------')
      }
    )
}



 handleAcceptedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ selectedFiles: files });
};

handleRejectedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ rejectedFiles : files });

} 

/**
 * Formats the size
 */
formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};


 handleselectedTypeGroup = selectedType =>{
     this.setState({ selectedType })
 }

 handleselectedFacilityGroup = selectedFacilities => {
  // Check if the user clicked "Select All" option
  if (selectedFacilities && selectedFacilities.some(option => option.value === "all")) {
    // If "Select All" is selected, get all facilities except the "Select All" option
    const allOptions = this.state.FacilityGroup[0].options.filter(option => option.value !== "all");
    this.setState({ selectedFacilities: allOptions });
  } else {
    // Normal selection behavior
    this.setState({ selectedFacilities });
  }
};

  handleSelectLocationGroup = selectedLocationsGroup => {
    this.setState({ selectedLocationsGroup });
  };

  handleSelectDestinationGroup = selectedDestination => {
    this.loadPlacesData(`?parent__id=${selectedDestination.value}`)
    let selectedLocationsGroup= { label: "Select Place", value: "" }
    this.setState({ selectedDestination, selectedLocationsGroup });
  };

  handleselectedRatingGroup = selectedRating => {
    this.setState({ selectedRating });
  };

  onInputChange(e){
    this.loadDestinationData(`?parent=null&search=${e}`)
  }

  onPlaceInputChange(e){
    if (this.state.selectedDestination.value)
      this.loadPlacesData(`?parent__id=${this.state.selectedDestination.value}&search=${e}`)
  }

  handleFacilitySubmit(e, values) {
    this.setState({ facilityloding: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/hotels/hotels_facilities/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ facilityloding: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          this.loadFacilitiesData()
                          this.setState({facilityloding: false, model_facilities: false, })
                          }
                      )
                  }    
              }
          )
  }

  handleHotelTypeSubmit(e, values) {
    this.setState({ typeloading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/hotels/hotels_types/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ typeloading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedType ={ label: data.name, value: data.id }
                          this.setState({typeloading: false, model_type: false, selectedType:selectedType })
                          }
                      )
                  }    
              }
          )
  }

  handleSubmit(e, values) {
    let description = document.getElementById("textarea").value
    if(! this.state.selectedLocationsGroup.value){
      toastr.error(`Select Place`,"") 
    }else if(this.state.selectedFiles.length === 0){

      toastr.error(`Select Images`,"") 
    }else if (this.state.selectedFacilities.length === 0) {
      toastr.error(`Select Facilities`,"") 
    }else{
      this.setState({ loading: true })
      const { selectedFacilities } = this.state
      let facilities = []
      for (let i =0; i<selectedFacilities.length; i++){
        facilities.push(selectedFacilities[i].value)
      }

      const formData = new FormData();
      const img = this.state.selectedFiles
      for(let i=0 ; i<img.length; i++){
        formData.append(
          "images",
          this.state.selectedFiles[i]
      );
      }
      formData.append("name",values.name)
      formData.append("hotel_type",this.state.selectedType.value)
      formData.append("rating",this.state.selectedRating.value)
      formData.append("place",this.state.selectedLocationsGroup.value)
      formData.append("destination",this.state.selectedDestination.value)
      formData.append("address",values.address)
      formData.append("zip_code",values.zip_code)
      formData.append("coordinates",values.coordinates)
      formData.append("facilities",facilities)
      formData.append("description",description)
      formData.append("contact_person",values.contact_person)
      formData.append("contact",values.contact)
      formData.append("contact_email",values.contact_email)
      formData.append("created_by",this.obj.user.id)

     
      axios.post(
        `${BaseUrl}/api/hotels/add_hotels/`,
        formData,
        {
            headers: {
                "Content-type": "multipart/form-data",
                "Authorization": `Bearer ${this.obj.access}`
            },                    
        }
    )
    .then(res => {
        toastr.success(`${res.data.name} Added Successfully`,"") 
        this.props.history.push(`/hotel-pricing/${res.data.id}`)
        this.setState({ loading: false })
    })
    .catch(err => {
      toastr.error(`Somthing Went Wrong`,"") 
      this.setState({ loading: false })
        console.log(err, "----------------------error");
    })
    }
  }

  render() {
    const { selectedLocationsGroup, LocationGroup, selectedType, TypeGroup, selectedFacilities,
      FacilityGroup, selectedRating, DestinationGroup, selectedDestination } = this.state;

      const HotelFacility = ({ innerRef, innerProps, isDisabled, children }) =>
      !isDisabled ? (
          <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
              {children}
              <Link to="#" onClick={this.tog_center}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null;

      const HotelType = ({ innerRef, innerProps, isDisabled, children }) =>
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
            </div>
        ) : null;


    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Hotels" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Hotel Detail</h4>
                        <Row>
                          <Col md="12">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Hotel Name</Label>
                              <AvField
                                name="name"
                                placeholder="Hotel Name"
                                type="text"
                                errorMessage="Enter Hotel Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                                
                              />
                            </div>
                          </Col> 
                        </Row>

                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Hotel Type</Label>
                                <Select 
                                value={selectedType}
                                onChange={this.handleselectedTypeGroup}
                                options={TypeGroup}
                                components={{ Menu: HotelType }}
                                classNamePrefix="select2-selection"
                                />
                            </div>
                          </Col>

                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Rating</Label>
                                  <Select 
                                  value={selectedRating}
                                  onChange={this.handleselectedRatingGroup}
                                  options={RatingGroup}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                          </Col>
                  
                        </Row>
                        <Row>
                          <Col md="12">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="address">Address</Label>
                                <AvField
                                  name="address"
                                  placeholder="Hotel Address"
                                  type="text"
                                  errorMessage="Enter Hotel Address"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="address"
                                  
                                />
                              </div>
                            </Col> 

                        </Row>

                        <Row>
                            <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Destination</Label>
                                  <Select 
                                  onInputChange={this.onInputChange}
                                  value={selectedDestination}
                                  onChange={this.handleSelectDestinationGroup}
                                  options={DestinationGroup}
                                  classNamePrefix="select2-selection"
                                  />
                            </div>
                            </Col>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Place</Label>
                                    <Select 
                                        onInputChange={this.onPlaceInputChange}
                                        value={selectedLocationsGroup}
                                        onChange={this.handleSelectLocationGroup}
                                        options={LocationGroup}
                                        classNamePrefix="select2-selection"
                                    />
                                </div>
                            </Col>
                            
                
                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                <AvField
                                  name="zip_code"
                                  label="Pin Code"
                                  placeholder="Enter Only number"
                                  type="number"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    
                                    maxLength: {
                                      value: 6,
                                      errorMessage: "Numbers must be less than 7 digit"},
                                    minLength: {
                                      value: 6,
                                      errorMessage: "Numbers must be Grater than 5 digit"}   
                                  }}
                                />
                              </div>
                            </Col> 
                        </Row>
                        <Row>
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label " htmlFor="elevation">Contact Person</Label>
                                  <AvField
                                  name="contact_person"
                                  placeholder="Contact Person"
                                  type="text"
                                  errorMessage="Enter Contact Person"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="elevation"
                                  
                                  />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="contact"> Contact Number</Label>
                                  <AvField
                                  name="contact"
                                  placeholder="Contact Number"
                                  type="text"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                      required: { value: true },
                                  }}
                                  id="contact"
                                  
                                  />
                              </div>
                          </Col> 
                        </Row>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                            <Label className="form-label " htmlFor="contact_email"> Contact Email</Label>
                                <AvField
                                name="contact_email"
                                placeholder="Contact Email"
                                type="text"
                                className="form-control"
                                errorMessage="Enter Contact Person Email"
                                validate={{
                                    required: { value: true },
                                }}
                                id="contact_email"
                                
                                />
                            </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="coordinates">Location Coordinates</Label>
                                <AvField
                                  name="coordinates"
                                  placeholder="Hotel Location Coordinates"
                                  type="text"
                                  errorMessage="Enter Hotel Location Coordinates"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="coordinates"
                                  
                                />
                              </div>
                            </Col> 

                        </Row>
                        <Row>    
                          <Col md="12">
                              <div className="mb-3">
                                  <Label className="form-label">Facilities</Label>
                                  <Select 
                                  value={selectedFacilities}
                                  isMulti={true}
                                  onChange={this.handleselectedFacilityGroup}
                                  options={FacilityGroup}
                                  components={{ Menu: HotelFacility }}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                          </Col>
                        </Row>    
                        <Row>
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="price">Description</Label>
                              <Input
                                type="textarea"
                                id="textarea"
                                rows="3"
                                placeholder="About Hotel"
                              />
                          </div>
                        </Row>  


                        {/* Image  */}
                        <Row>
                          <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
        
                            >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                  <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only .jpeg/.png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                  </div>
                                  {this.state.errors?
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {this.state.errors}
                                  </p>:""}
                              </div>
                              )}
                            </Dropzone>
                            <div
                                className="dropzone-previews mt-3"
                                id="file-previews"
                              >
                            {this.state.selectedFiles.map((f, i) => {
                            return (
                                <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                                >
                                <div className="p-2">
                                    <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <Link
                                        to="#"
                                        className="text-muted fw-bold"
                                        >
                                        {f.name}
                                        </Link>
                                        <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                    </Row>
                                </div>
                                </Card>
                              );
                              })}
                              {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                               {this.state.rejectedFiles.map((f, i) => {
                            return (
                                <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-rejected_file"}
                                >
                                <div className="p-2">
                                    <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <Link
                                        to="#"
                                        className="text-muted fw-bold"
                                        >
                                        {f.name}
                                        </Link>
                                        <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                    </Row>
                                </div>
                                </Card>
                              );
                              })}
                            </div>
                          </Col>
                        </Row> 
                        <FormGroup className="mb-0 mt-1">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>

              </Row>
            </AvForm>
              {/* Add Facilities Model */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                  isOpen={this.state.model_facilities}
                  toggle={this.tog_center}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_facilities: false })}>
                  Add Hotel Facility
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleFacilitySubmit} >
            
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="name">Hotel Facility</Label>
                            <AvField
                              name="name"
                              placeholder="Hotel Facility"
                              type="text"
                              errorMessage="Enter Hotel Facility"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="name"
                              
                            />
                          </div>
                        </Col> 
                      </Row>
                                        
                      <FormGroup className="mb-0">
                        {this.state.facilityloding?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
              {/* Add Hotel Type Model */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_center}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Hotel Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleHotelTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Type Name</Label>
                           <AvField
                             name="name"
                             placeholder="Hotel Type"
                             type="text"
                             errorMessage="Enter Hotel Type"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.typeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
   

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddHotels;



    